import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { 
  CallIcon, 
  ClockIconV3, 
  PersonIcon,
  CheckCircleIcon,
  XCircleIcon
} from "../../../images/icons/icons";
import { formatDateTime } from "../../common-data/Converts";

const PTTrialLogCards = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((trialLog, index) => {
          return (
            <div
              className="log-card"
              key={index}
              style={{ overflow: "hidden", paddingBottom: "8px" }}
            >
              <div className="all-info">
                 <div className="log-card-top">
                   <div className="profile-name-number" style={{height: "auto", minHeight: "auto"}}>
        
                     <div className="name-number" style={{height: "auto", minHeight: "auto", flex: "1"}}>
                       <h3 className="lead-name" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                         <PersonIcon /> {trialLog?.user_name || "NA"}
                       </h3>
                       <p className="number" style={{display: "flex", alignItems: "center", gap: "6px",marginTop:"px"}}>
                         <CallIcon /> {trialLog?.user_mobile || "NA"}
                       </p>
                       <span className="value gym-name semi-bold">
                         {trialLog?.gym_name || "NA"}
                       </span>
                       <span className="value semi-bold" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                         <PersonIcon /> Trainer: {trialLog?.trainer_name || "NA"}
                       </span>
                       <span className="value semi-bold" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                        <ClockIconV3 color="#2c3e50" /> Check-in: {formatDateTime(trialLog?.date_added || "-")}
                       </span>
                       <span className="value semi-bold" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                         PT Trial: {trialLog?.three_day_assigned ? (
                           <><CheckCircleIcon /> Assigned</>
                         ) : (
                           <><XCircleIcon /> Not Assigned</>
                         )}
                       </span>
                       <span className="value semi-bold">
                         Progress: {trialLog?.three_day_done_count || 0}/3 sessions
                       </span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default PTTrialLogCards;
